export default __webpack_public_path__ + "static/media/icon-Table-Edit.e3253e39.svg";